import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";
import StripeClimateBadgeIframe from "../components/StripeClimateBadgeIframe";

/** Québec legal entity and mailing address (fixed copy; not localized). */
const LEGAL_NAME = "Jeux Puzzle Interact";
const NEQ_LINE = "NEQ: 2281979809";
const STREET = "604-900 Rockland Outremont";
const POSTAL_CODE = "H2V 3A2";
const REGION = "Quebec, Canada";

export default function LegalCompanyIdentity() {
    return (
        <>
            <Box
                component="address"
                sx={{
                    fontStyle: "normal",
                    mb: 2,
                    textAlign: "left",
                    color: "text.secondary",
                }}
            >
                <Typography variant="body1" sx={{ textAlign: "left" }}>
                    <strong>{LEGAL_NAME}</strong>
                    <br />
                    {NEQ_LINE}
                    <br />
                    {STREET}
                    <br />
                    {POSTAL_CODE}
                    <br />
                    {REGION}
                </Typography>
            </Box>
            <StripeClimateBadgeIframe sx={{ mt: "15px" }} />
        </>
    );
}
